module.exports = __webpack_public_path__ + "img/Flag_of_Guinea-Bissau.7c7e5175.svg";